// Italian number formatting (1.234,56 / 75,5%) mirrored from the backend report.

function itNumber(n, digits) {
  const v = Number.isFinite(n) ? n : 0;
  const neg = v < 0;
  const fixed = Math.abs(v).toFixed(digits);
  const [intPartRaw, dec] = fixed.split(".");
  const intPart = intPartRaw.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${neg ? "-" : ""}${intPart}${dec ? "," + dec : ""}`;
}

export function eur(n, digits = 0) {
  return `${itNumber(Number(n || 0), digits)} €`;
}

export function pct(n, digits = 1) {
  return `${itNumber(Number(n || 0), digits)}%`;
}

export function num(n, digits = 0) {
  return itNumber(Number(n || 0), digits);
}

export function score(n, max = 10, digits = 1) {
  if (n === null || n === undefined) return "—";
  return `${itNumber(Number(n), digits)}/${max}`;
}

export function rank(n) {
  if (n === null || n === undefined) return "—";
  return `#${Math.round(n)}`;
}

// Percentage delta. Returns { text, dir } with dir in up|down|flat|none.
export function deltaPct(current, base) {
  if (base === null || base === undefined || base === 0) return { text: "—", dir: "none" };
  const change = ((current - base) / Math.abs(base)) * 100;
  const dir = change > 0 ? "up" : change < 0 ? "down" : "flat";
  const sign = change > 0 ? "+" : change < 0 ? "−" : "";
  return { text: `${sign}${itNumber(Math.abs(change), 1)}%`, dir };
}

export function deltaPoints(current, base) {
  if (current === null || current === undefined || base === null || base === undefined)
    return { text: "—", dir: "none" };
  const d = current - base;
  const dir = d > 0 ? "up" : d < 0 ? "down" : "flat";
  const sign = d > 0 ? "+" : d < 0 ? "−" : "";
  return { text: `${sign}${itNumber(Math.abs(d), 1)} pt`, dir };
}

// Booking rank: a lower number is better, so improvement = base - current.
export function deltaPosition(current, base) {
  if (current === null || current === undefined || base === null || base === undefined)
    return { text: "—", dir: "none" };
  const d = base - current;
  const dir = d > 0 ? "up" : d < 0 ? "down" : "flat";
  const sign = d > 0 ? "+" : d < 0 ? "−" : "";
  return { text: `${sign}${Math.abs(d)} pos.`, dir };
}

export const STRATEGY_LABEL = {
  ATTIVA: "Strategia prezzi attiva",
  IN_ATTIVAZIONE: "Strategia in fase di attivazione",
};

export const STATUS_LABEL = {
  OPERATIVA: "Operativa",
  COLLAUDO: "In collaudo",
};

export const URGENCY = {
  low: { label: "Priorità bassa", color: "#4F9D69" },
  medium: { label: "Priorità media", color: "#D4A359" },
  high: { label: "Priorità alta", color: "#E05A2C" },
};

export const STARTING_PARAMS = [
  { key: "airbnb_score", label: "Punteggio Airbnb", unit: "/5" },
  { key: "booking_score", label: "Punteggio Booking", unit: "/10" },
  { key: "review_average", label: "Media recensioni", unit: "" },
  { key: "adr", label: "ADR", unit: "€" },
  { key: "sales_volume", label: "Volume vendite", unit: "" },
  { key: "occupancy_pct", label: "Occupazione", unit: "%" },
  { key: "conversion_rate", label: "Conversion", unit: "%" },
  { key: "monthly_revenue", label: "Fatturato mensile", unit: "€" },
];

export const MONTHS_IT = [
  "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
  "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre",
];
